require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./manifestations-internes-1-12-3.json") })
        }
      }, "path---manifestations-internes-1-12-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---manifestations-internes-1-12-3!./.cache/json/manifestations-internes-1-12-3.json
// module id = 487
// module chunks = 231608221292675